import { SetupChecklistLayout } from "Components/Dashboard/SetupChecklist/SetupChecklistLayout";
import { SetupChecklistRow } from "Components/Dashboard/SetupChecklist/SetupChecklistRow";
import { BlDivider } from "Components/Shared/BlDivider";
import { useBankingAccounts } from "Api/Queries/Accounts/useBankingAccounts";
import { useHasPrimaryAccount } from "Hooks/useHasPrimaryAccount";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";

const RESOURCES = Resources.Components.SetupChecklist;

export const MerchantSetupChecklistCard = () => {
  const { data: accounts } = useBankingAccounts();
  const { hasPrimaryAccount } = useHasPrimaryAccount();
  const { t } = useResource();

  // undefined means loading, a query error, or an unknown market rail
  // (region-less context) — the hook cannot answer the question, so nagging
  // the merchant would be a guess. Only a definite false shows the card; a
  // definite false also guarantees the accounts query has settled.
  if (hasPrimaryAccount !== false) {
    return null;
  }

  // Merchants connect a bank during onboarding, so this step is normally
  // already done — it resurfaces only if they later delete every account.
  const hasConnectedAccount = (accounts?.items.length ?? 0) > 0;

  return (
    <SetupChecklistLayout
      title={t(RESOURCES.MerchantTitle)}
      subtitle={t(RESOURCES.MerchantSubtitle)}
      completedCount={hasConnectedAccount ? 1 : 0}
      totalCount={2}
    >
      <SetupChecklistRow
        state={hasConnectedAccount ? "done" : "active"}
        stepNumber={1}
        title={t(RESOURCES.Steps.ConnectBank.Title)}
        description={t(RESOURCES.Steps.ConnectBank.Description)}
        ctaText={t(RESOURCES.Steps.ConnectBank.Action)}
        ctaUrl={appUrl("banking-auth")}
      />
      <BlDivider marginY={0} />
      <SetupChecklistRow
        state={hasConnectedAccount ? "active" : "upcoming"}
        stepNumber={2}
        title={t(RESOURCES.Steps.SetPrimaryAccount.Title)}
        description={t(RESOURCES.Steps.SetPrimaryAccount.Description)}
        ctaText={t(RESOURCES.Steps.SetPrimaryAccount.Action)}
        ctaUrl={appUrl("bank-address-list")}
        // A primary cannot be chosen before any account exists, so no early
        // "Start" link while the connect step is still ahead.
        isUpcomingLinkHidden
      />
    </SetupChecklistLayout>
  );
};
